<template>
  <div id="list_demo">
    <banner-back :title="title"></banner-back>
    <router-link to="/" tag="button" class="icon-uep icon-uep-back button">
      Retour
    </router-link>
    <keep-alive>
      <demo class="md-transparent" :type="type" :plugin="plugin"></demo>
    </keep-alive>
  </div>
</template>

<script>
  import BannerBack from '@/components/BannerBack'
  import Highlight from '@/components/Highlights'
  import Demo from '@/components/Demo'
  import Loop from '@/components/demoComponents/Loop'
  import Chromless from '@/components/demoComponents/Chromless'
  import PlayBackRates from '@/components/demoComponents/PlayBackRates'

  export default {
    name: 'list-demo',
    props: {
      type: {
        type: String,
        default: 'Vue!'
      },
      plugin: {
        type: String,
        default: 'simple'
      },
      title: {
        type: String,
        default: 'Vue!'
      },
      componentName: {
        type: String,
        default: 'loop'
      },
      cdn: {
        type: Boolean,
        default: true
      }
    },
    components: { Demo, BannerBack,Loop,Chromless,PlayBackRates},
  }
</script>

<style>
  .icon-uep.icon-uep-back {
    background: transparent;
    border: 0;
    cursor: pointer;
    box-shadow : none ;
    color : #0a2239 !important;
  }


</style>



// WEBPACK FOOTER //
// DemoItem.vue?83efc4f0